import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["size", "style", "className"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';

var SmallPlaceholder = function SmallPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "5",
    stroke: "currentColor",
    strokeWidth: "1.952",
    strokeLinecap: "round",
    strokeDasharray: "0.85 3.42"
  }));
};

SmallPlaceholder.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var MediumPlaceholder = function MediumPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDasharray: "1 4"
  }));
};

MediumPlaceholder.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LargePlaceholder = function LargePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDasharray: "2 4"
  }));
};

LargePlaceholder.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExtraLargePlaceholder = function ExtraLargePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDasharray: "3 4"
  }));
};

ExtraLargePlaceholder.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var placeholders = {
  s: SmallPlaceholder,
  m: MediumPlaceholder,
  l: LargePlaceholder,
  xl: ExtraLargePlaceholder
};
var defaultStyles = StyleSheet({
  icon: {
    flex: '0 0 auto'
  }
});
export function makeIconComponent(icons) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Unknown';
  return function Icon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 'm' : _ref$size,
        style = _ref.style,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, _excluded);

    var s = useStyles(defaultStyles);
    var Icon = icons[size];

    if (!Icon) {
      var _context;

      Icon = placeholders[size];
      console.warn(_concatInstanceProperty(_context = "Icon \"".concat(name, "\" is using the placeholder icon for size \"")).call(_context, size, "\""));
    }

    return /*#__PURE__*/React.createElement(Icon, _extends({}, s.with('icon')({
      style: style,
      className: className
    }), props));
  };
}